// OrgChartZoom — zoom toolbar for the chart canvas: −, live % readout, +,
// and fit-to-screen.

import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common';
import { ZOOM_STEP } from './orgChartLayout';

interface OrgChartZoomProps {
  scale: number;
  onZoom: (factor: number) => void;
  onFit: () => void;
}

const OrgChartZoom = ({ scale, onZoom, onFit }: OrgChartZoomProps) => {
  const { t } = useTranslation();
  return (
    <div className='org-chart__zoom' onMouseDown={(e) => e.stopPropagation()}>
      <button
        type='button'
        className='org-chart__zoom-btn'
        aria-label={t('structure_chart_zoom_out')}
        onClick={() => onZoom(1 / ZOOM_STEP)}
      >
        <Icon name='minus' size={16} />
      </button>
      <span className='org-chart__zoom-pct'>{Math.round(scale * 100)}%</span>
      <button
        type='button'
        className='org-chart__zoom-btn'
        aria-label={t('structure_chart_zoom_in')}
        onClick={() => onZoom(ZOOM_STEP)}
      >
        <Icon name='plus' size={16} />
      </button>
      <span className='org-chart__zoom-divider' />
      <button
        type='button'
        className='org-chart__zoom-btn'
        aria-label={t('structure_chart_fit')}
        onClick={onFit}
      >
        <Icon name='maximize-2' size={16} />
      </button>
    </div>
  );
};

export default OrgChartZoom;
